import { Skeleton } from '../../components/Skeleton';
import { TextBlock } from './wrapper';

const SkeletonTextBlock = () => (
  <TextBlock>
    <Skeleton $width="100%" $height="1.5em" />
    <Skeleton $width="90%" $height="1.5em" />
    <Skeleton $width="60%" $height="1.5em" />
  </TextBlock>
);

export default SkeletonTextBlock;
